import { render, staticRenderFns } from "./AuditorDesignatedPersonCertificateInfo.vue?vue&type=template&id=568c2229&scoped=true&"
import script from "./AuditorDesignatedPersonCertificateInfo.vue?vue&type=script&lang=js&"
export * from "./AuditorDesignatedPersonCertificateInfo.vue?vue&type=script&lang=js&"
import style0 from "./AuditorDesignatedPersonCertificateInfo.vue?vue&type=style&index=0&id=568c2229&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c2229",
  null
  
)

export default component.exports